"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editRegisterGrade = editRegisterGrade;
exports.queryRegisterGrade = queryRegisterGrade;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryRegisterGrade(params) {
  return (0, _request.default)({
    url: '/portal/system/class/queryRegisterGrade',
    method: 'get',
    params: params
  });
}
function editRegisterGrade(data) {
  return (0, _request.default)({
    url: '/portal/system/class/editRegisterGrade',
    method: 'post',
    data: data
  });
}